import jwtAuthAxios from 'app/services/auth/jwtAuth'
const customerServices = {}

customerServices.getCustomerLookupList = async (filter) => {
    let url = filter?.firstName ? `/api/Customer/lookup/list?search=${filter.firstName}` : `/api/Customer/lookup/list`
    const { data } = await jwtAuthAxios.get(url, filter).catch(function (error) {
        if (error.response) {
            throw error.response.data
        } else if (error.request) {
            console.log(error.request)
            throw Error('request timed out')
        } else {
            console.log('Error', error.message)
        }
        console.log(error.config)
        throw Error(error.message)
    })
    return data
}

customerServices.getCustomerLookupById = async (key) => {
    let url = `/api/Customer/lookup/${key}`
    const { data } = await jwtAuthAxios.get(url, '').catch(function (error) {
        if (error.response) {
            throw error.response.data
        } else if (error.request) {
            throw Error('request timed out')
        } else {
            console.log('Error', error.message)
        }
        console.log(error.config)
        throw Error(error.message)
    })
    return data
}

customerServices.getMergePreview = async (keepCustomerId, removeCustomerId) => {
    const url = `/api/Customer/merge/preview?keepCustomerId=${keepCustomerId}&removeCustomerId=${removeCustomerId}`
    const { data } = await jwtAuthAxios.get(url).catch(function (error) {
        if (error.response) {
            throw error.response.data
        }
        throw Error(error.message || 'request failed')
    })
    return data
}

customerServices.mergeCustomers = async (payload) => {
    const { data } = await jwtAuthAxios.post('/api/Customer/merge', payload).catch(function (error) {
        if (error.response) {
            throw error.response.data
        }
        throw Error(error.message || 'request failed')
    })
    return data
}

export default customerServices
